<script lang="ts">
	import { dbgState } from "../../game/debugger";
	import Icon from "./Icon.svelte";
	import Template from './Template.svelte';

	export let iconHeight: number = 0;

	let showBubble: boolean = true;

	function toggle( e: Event ) {
		showBubble = ! showBubble;
		e.stopPropagation();
	}

	function close( e: Event ) {
		showBubble = false;
		e.stopPropagation();
	}

	function ignore( e: Event ) {
		e.stopPropagation();
	}
</script>

<div class="error-icon" style={ `top: ${ iconHeight }px` } on:click={ toggle  }>
	<Icon i="times" />

	{#if showBubble}
		<div class={ 'bubble ' + ( iconHeight < 200 ? 'down' : 'up' ) } on:click={ ignore }>
			<h1>
				<button on:click={ close }>
					<Icon i="times" />
				</button>

				{ $dbgState.error.title }
			</h1>

			<p>
				Your program has crashed. Python says:
			</p>

			<pre>{ $dbgState.error.message }</pre>

			{#if ( $dbgState.error.errorHelp ) }
				<h2>But what does that mean?</h2>

				<div>
					<Template
						template={ $dbgState.error.errorHelp }
					/>
				</div>
			{/if}
		</div>
	{/if}
</div>

<style>
	.error-icon {
		position: absolute;
		top: 0;
		right: -20px;
		background-color: #f00;
		z-index: 100;
		width: 14px;
		height: 14px;
		border-radius: 5px;
		border: 1px solid #800;
		color: white;
		line-height: 14px;
    	font-size: 14px;
    	text-align: center;
	}

	.bubble {
		position: relative;
		width: 400px;
		max-height: 300px;
		border-radius: 10px;
		top: 25px;
		left: -3px;
		border: 3px solid #900;
    	background-color: #fee;
		text-align: left;
		color: black;
		line-height: 1.5em;
	}

	.bubble * {
		margin-left: 10px;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.bubble h1 {
		position: relative;
		font-size: 16px;
		font-weight: bold;
		line-height: 16px;
		margin: 0px;
		padding: 10px;
		background-color: #900;
		color: white;
	}

	.bubble h1 button {
		position: absolute;
		top: 3px;
		right: 3px;
		margin: 0px;
		background-color: #f00;
		color: white;
		border: 1px solid #700;
		box-shadow: none;
	}

	.bubble pre, :global( .bubble code ) {
		border: 1px solid #ccc;
		background-color: #fff;
		border-radius: 2px;
	}

	.bubble pre {
		max-height: 25em;
		overflow: auto;
		padding: 10px;
	}

	:global( .bubble code ) {
		padding: 2px;
	}

	.bubble:after {
		content: '';
		position: absolute;
		display: block;
		width: 0;
		z-index: 1;
		border-style: solid;
		border-width: 20px 0 0 20px;
		border-color: transparent transparent transparent #900;
		top: -20px;
		left: 20px;
		margin-left: -10px;
	}
</style>